import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-card-doubts',
    templateUrl: './card-doubts.component.html',
    styleUrls: ['./card-doubts.component.scss'],
    standalone: false
})
export class CardDoubtsComponent implements OnInit {
	@Input() title: string = '';
	@Input() answer: string = '';
	@Input() id!: number;

	opened: boolean = false;

	constructor() {}

	ngOnInit(): void {}

	expandRow(event: any) {
		if (event.currentTarget.nextElementSibling.classList.contains('show-detail')) {
			this.opened = false;
			event.currentTarget.nextElementSibling.classList.remove('show-detail');
			event.currentTarget.nextElementSibling.classList.add('hidden');
			event.currentTarget.classList.remove('opened');
		} else {
			this.opened = true;
			event.currentTarget.nextElementSibling.classList.remove('hidden');
			event.currentTarget.nextElementSibling.classList.add('show-detail');
			event.currentTarget.classList.add('opened');
		}
	}
}
